import React, { Component } from "react";

class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.checked || null }
    this.onChange = this.onChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.setState({ value: this.props.checked})
    }
  }

  onChange(e) {
    e.persist();
    this.setState({ value: e.target.checked }, () => {
      this.props.onChange(e);
    })
  }

  get value() {
    return this.state.value;
  }

  get checked() {
    if (this.props.checked !== undefined) {
      return this.props.checked
    }
    return this.state.value
  }

  renderLabel() {
    if (this.props.label) {
      return (
        <label className="Text marginLeft-s fontSize-s color-grey-d" htmlFor={this.props.id}>
          {this.props.label}
        </label>
      )
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <input
          id={this.props.id}
          {...this.props}
          type="checkbox"
          checked={this.state.value}
          onChange={this.onChange}
        />
        {this.renderLabel()}
      </div>
    )
  }
}

CheckBox.defaultProps = {
  id: "checkbox",
  // checked: false,
  onChange(){},
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/CheckBox.js